import { Placement } from "./Placement";
import EnemySpawn from "../components/object-graphics/EnemySpawn";
import { LAYERS } from "../helpers/consts";

export class EnemySpawnPlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.enemyType = properties.enemyType;
    this.direction = properties.direction;
    this.spawnsBullets = properties.spawnsBullets; //only for Ciabatta...
  }

  getEditingLayer() {
    return LAYERS.PICKUPS;
  }

  spawnPlacementOnStart() {
    return {
      x: this.x,
      y: this.y,
      type: this.enemyType,
      direction: this.direction,
      //Only for Ciabatta...
      spawnsBullets: this.spawnsBullets,
    };
  }

  appearsOnScreen() {
    return this.level.isEditMode;
  }

  renderComponent() {
    return <EnemySpawn enemyType={this.enemyType} direction={this.direction} />;
  }
}
